/* ==========================================================================

 MyProjectsView

 Author:      Dave Taylor (http://davetayls.me)
 Description: Handles the list of projects on the My Projects Listing page

 ========================================================================== */
'use strict';

var Backbone = require('backbone'),
  $ = require('jquery'),

  ITEM_HIDDEN_CLASS = 'MyProjects-item--hidden',
  ITEM_VISIBLE_CLASS = 'MyProjects-item--visible',
  ITEM_PAGE_SIZE = 8,
  MORE_AVAILABLE_CLASS = 'MyProjects--moreAvailable',

  MyProjectsView = Backbone.View.extend({

    initialize: function() {
      this.$footer = this.$('.MyProjects-footer');
      this.$loadMoreButton = $('<button class="Button Button--loadMore">Show more</button>');
      this.$footer.append(this.$loadMoreButton);
      this.$('.MyProjects-item').addClass(ITEM_HIDDEN_CLASS);
      this.showNextPageOfProjects();
    },

    events: {
      'click .Button--loadMore': 'showNextPageOfProjects'
    },

    showNextPageOfProjects: function() {
      var $hiddenItems = this.$('.' + ITEM_HIDDEN_CLASS);
      if ($hiddenItems.length < ITEM_PAGE_SIZE) {
        this.$el.removeClass(MORE_AVAILABLE_CLASS);
      } else {
        this.$el.addClass(MORE_AVAILABLE_CLASS);
      }
      $hiddenItems.slice(0, ITEM_PAGE_SIZE)
        .removeClass(ITEM_HIDDEN_CLASS)
        .addClass(ITEM_VISIBLE_CLASS);
    },

    removeProjectFromList: function(projectModel) {
      this.$('.MyProjects-item[data-project="' + projectModel.id + '"]').remove();
      this.$('.' + ITEM_HIDDEN_CLASS).eq(0)
        .removeClass(ITEM_HIDDEN_CLASS)
        .addClass(ITEM_VISIBLE_CLASS);
      this.checkShowMore();
    },

    checkShowMore: function() {
      var $hiddenItems = this.$('.' + ITEM_HIDDEN_CLASS);
      if ($hiddenItems.length < ITEM_PAGE_SIZE) {
        this.$el.removeClass(MORE_AVAILABLE_CLASS);
      } else {
        this.$el.addClass(MORE_AVAILABLE_CLASS);
      }
    }

  }, {
    create: function($parent) {
      $parent.find('.MyProjects').each(function(n, el) {
        new MyProjectsView({
          el: el
        });
      });
    }
  });

module.exports = MyProjectsView;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/MyProjectsView.js